import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { omit, isEqual } from 'lodash-es';

export interface AbstractControlWithWarning extends AbstractControl {
  warnings?: any;
}

export const validateAllFormFields = (f: AbstractControl) => {
  if (f instanceof FormControl) {
    f.markAsTouched({ onlySelf: true });
  } else if (f instanceof FormGroup) {
    Object.keys(f.controls).forEach((fc) => {
      const c = f.get(fc)!;
      validateAllFormFields(c);
    });
  }
};

export function atLeastOneExistsValidator(controlNames: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const controls = controlNames.map((n) => control.get(n));

    if (controls.some((c) => !c)) {
      return null;
    }

    if (controls.some((c) => c!.touched)) {
      controls.forEach((c) => c!.markAsTouched());
    }

    if (controls.every((c) => !c!.value)) {
      controls.forEach((c) => c!.setErrors({ ...c!.errors, atLeastOneDoesNotExist: true }));
      return { atLeastOneDoesNotExist: true };
    } else {
      controls.forEach((c) => {
        const omittedErrors = omit(c!.errors, 'atLeastOneDoesNotExist');
        if (isEqual(omittedErrors, {})) {
          c!.setErrors(null);
        } else {
          c!.setErrors(omittedErrors);
        }
      });
      return null;
    }
  };
}
